"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processSupplierOrderLineMessage = void 0;
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const addOrderNote_1 = require("./addOrderNote");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderById_1 = require("./getOrderById");
const getOrderLineById_1 = require("./getOrderLineById");
const processSupplierOrderLineMessage = async (supabase, order_id, order_line_id, message, include_copy) => {
    try {
        // get the order
        const order = await (0, getOrderById_1.getOrderById)(supabase, order_id);
        const order_line = await (0, getOrderLineById_1.getOrderLineById)(supabase, order_line_id);
        if (!order_line.versions)
            return false;
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
        // create a new order note.
        const note = {
            order_item_id: order_line_id,
            note: message,
            order_id: order_id,
            pinned: true,
            created_by: helpers_1.ADMIN_USER_ID,
            created_name: latest_version?.config?.supplier?.name,
            type: "SUPPLIER_MESSAGE",
        };
        await (0, addOrderNote_1.addOrderNote)(supabase, note);
        if (include_copy) {
            // send copy of request
        }
        // email support with request details
        const request_support_email = {
            language_code: "en",
            template_id: helpers_1.EMAIL_SUPPORT_SUPPLIER_ORDER_LINE_MESSAGE,
            order_id: order.id,
            order_line_id: order_line_id,
            data: {
                message: message,
                supplier: {
                    id: latest_version?.config?.supplier?.id,
                    name: latest_version?.config?.supplier?.name,
                },
            },
        };
        await (0, sendEmail_1.sendEmail)(request_support_email);
        return true;
    }
    catch (error) {
        throw new Error(error.message);
    }
};
exports.processSupplierOrderLineMessage = processSupplierOrderLineMessage;
